import React, { Fragment, useState } from "react"
import DateFnsUtils from "@date-io/date-fns"
import { makeStyles } from "@material-ui/core"
import IconButton from "@material-ui/core/IconButton"
import Close from "@material-ui/icons/Close"

import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider,
} from "@material-ui/pickers"

const useStyles = makeStyles(() => ({
    timeWrap: {
        transform: "translateY(-16px)",
    },
    timePicker: {
        width: 150,
        margin: 0,
    },
    iconButton: {
        padding: "0px 5px 3px",
    },
    textLabel: {
        paddingBottom: 2,
    },
}))
interface ComponentProps {
    onSelectDateRange: (dateRange: Date[]) => void,
}

const TimePicker = (props: ComponentProps) => {
    const classes = useStyles()
    const { onSelectDateRange } = props
    const [ dateRange, setDateRange ] = useState<Date[]>([])
    const [ startDate, endDate ] = dateRange
    const handleChangeStartDate = (date: Date | null) => {
        if (date && date.toString() === "Invalid Date") {
            return
        }
        const newDateRange = []
        if (date !== null) {
            const time = (date as Date).setHours(0,0,0)
            newDateRange.push(new Date(time))
        }
        setDateRange(newDateRange)
        onSelectDateRange(newDateRange)
    }
    const handleChangeEndDate = (date: Date | null) => {
        if (date && date.toString() === "Invalid Date") {
            return
        }
        const newDateRange = [ startDate ]
        if (date !== null) {
            const time = (date as Date).setHours(0,0,0)
            newDateRange.push(new Date(time))
        }
        setDateRange(newDateRange)
        onSelectDateRange(newDateRange)
    }
    return (
        <div className={classes.timeWrap}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Fragment>
                    <KeyboardDatePicker
                        autoOk
                        disableToolbar
                        variant="inline"
                        format="MM/dd/yyyy"
                        margin="normal"
                        label={(
                            <div className={classes.textLabel}>
                                开始时间
                                {
                                    startDate && (
                                        <IconButton
                                            className={classes.iconButton}
                                            onClick={() => handleChangeStartDate(null)}
                                        >
                                            <Close fontSize="small" />
                                        </IconButton>
                                    )
                                }
                            </div>
                        )}
                        value={startDate || null}
                        className={classes.timePicker}
                        onChange={handleChangeStartDate}
                    />
                    {
                        startDate && (
                            <KeyboardDatePicker
                                autoOk
                                disableToolbar
                                variant="inline"
                                format="MM/dd/yyyy"
                                margin="normal"
                                label={(
                                    <div className={classes.textLabel}>
                                        结束时间
                                        {
                                            endDate && (
                                                <IconButton
                                                    className={classes.iconButton}
                                                    onClick={() => handleChangeEndDate(null)}
                                                >
                                                    <Close fontSize="small" />
                                                </IconButton>
                                            )
                                        }
                                    </div>
                                )}
                                value={endDate || null}
                                className={classes.timePicker}
                                onChange={handleChangeEndDate}
                            />
                        )
                    }
                </Fragment>
            </MuiPickersUtilsProvider>
        </div>
    )
}

export default TimePicker
